import { siteMetadata } from 'config'
import { fetchJSON } from './fetch'

const { apiHost } = siteMetadata

export const fetchSearchResults = (query) => {
  const url = `${apiHost}/api/v1/internal/search?query=${query}`

  // have to specifically catch 404 errors so that they return as an error
  const response = fetchJSON(url)

  if (response === null) {
    throw new Error('search returned 404')
  }

  return response
}
